class OAuth {
  channel = null;
  deepLinkTarget = null;
  // deepLinkInfo = {
  //   requestURL: string,
  //   deepLinkTarget: string,
  //   securityCode?: string,
  //   activeTabKey?: string,
  // };
  deepLinkInfo = null;
}

export const oAuthStorage = new OAuth();
window["oAuthStorage"] = oAuthStorage;
